<template>
  <div class="resume-note" :class="{ _empty: empty }">
    <div class="resume-note__hide-cutouts-rounds"></div>
    <div class="resume-note__cutouts">
      <div v-for="circle in cutoutsNumber" :key="circle"></div>
    </div>

    <div class="resume-note__content">
      <button
        v-if="editable"
        class="base-btn resume-note__edit-btn"
        @click="toggleEditMode"
      >
        <slot name="edit-save-button-content" :edit-mode="editMode">
          <BaseSvg :name="editMode ? 'ico-save' : 'ico-edit'" width="1.2rem" height="1.2rem" />
        </slot>
      </button>

      <div v-if="value && (authorName || time)" class="resume-note__content-title">
        <span>{{ authorName }}</span>
        <time>{{ time }}</time>
      </div>

      <div class="resume-note__content-text" :style="{ opacity: empty && !editMode ? '0.7' : null }">
        <textarea-autosize
          ref="noteInput"
          v-if="editMode"
          v-model="editValue"
          class="reset-textarea"
          v-click-out="onClickInputOutsize"
          @keydown.native="onKeydown"
        ></textarea-autosize>
        <div v-else @click="onTextClick">{{ text }}</div>
      </div>

      <button
        v-if="textTooLong && !editMode"
        class="base-btn base-btn--x-small resume-note__expand-btn"
        :class="{ _expanded: expanded }"
        @click="expanded = !expanded"
      >
        <span>{{ $tResumePage(expanded ? 'Сollapse' : 'Expand') }}</span>
        <BaseSvg name="ico-arrow-down" width="0.6rem" height="0.4rem" />
      </button>
    </div>
  </div>
</template>

<script>
export default {
  name: 'ResumeNote',
  props: {
    value: {
      type: String,
      default: '',
    },
    authorName: {
      type: String,
      default: '',
    },
    time: {
      type: [String, Date],
      default: '',
    },
    maxUndisguisedLength: {
      type: [Number, String],
      default: '100',
    },
    cutoutsNumber: {
      type: Number,
      default: 18,
    },
    editable: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      loading: false,
      editMode: false,
      expanded: false,
      editValue: '',
    };
  },
  computed: {
    empty() {
      return !this.value;
    },
    textTooLong() {
      return !this.empty && this.value.length > Number(this.maxUndisguisedLength);
    },
    text() {
      if (this.textTooLong) {
        if (this.expanded) return this.value;
        return this.value.slice(0, this.maxUndisguisedLength - 1) + '...';
      }
      return this.empty ? this.$tResumePage('No notes') + '...' : this.value;
    },
  },
  methods: {
    toggleEditMode() {
      if (this.loading) return this.editMode = false;

      if (this.editMode) this.save();
      else this.openEditMode();
    },
    onKeydown($event) {
      if ($event.code !== 'Enter' || $event.shiftKey) return;
      $event.preventDefault();
      this.save();
    },
    onClickInputOutsize() {
      if (this.loading) return;
      this.editMode = false;
    },
    onTextClick() {
      if (!this.editable) return;
      if (this.empty) this.toggleEditMode();
    },
    async save() {
      if (this.value === this.editValue) return this.editMode = false;
      this.loading = true;

      // Important to use callback function for correct save
      const callback = () => {
        this.editMode = false;
        this.loading = false;
      };

      this.$emit('save', { value: this.editValue, callback });
    },
    openEditMode() {
      if (!this.editValue) this.editValue = this.value;
      this.editMode = true;
      setTimeout(() => {
        this.$refs.noteInput.$el.focus();
      });
    },
  },
};
</script>
